<template>
  <div class="applicationType div-layout">
    <div class="applicationType-main">
      <el-form :model="searchForm" :inline="true" label-position="right" label-width="100px">
        <el-form-item label="手机号：" prop="phone">
          <el-input v-model="searchForm.phone" maxlength="11" clearable @change="inputNum($event,'phone')" @input="inputNum($event,'phone')" />
        </el-form-item>
        <el-form-item label="IMEI号：" prop="imei">
          <el-input v-model="searchForm.imei" maxlength="15" clearable @change="inputNum($event,'imei')" @input="inputNum($event,'imei')" />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="getInfo"
          >
            查询
          </el-button>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="medium"
            @click="resetInput"
          >
            重置
          </el-button>
        </el-form-item>
      </el-form>
      <div class="applicationType-main-contain">
        <div class="applicationType-list">
          <el-table
            v-loading="listLoading"
            :data="pwdlList"
            highlight-current-row
            fit
            border
            element-loading-text="Loading"
            class="list-table"
            :span-method="objectRowSpanHandle"
          >
            <el-table-column type="index" width="55" align="center" label="序号" />
            <el-table-column label="设备IMEI号" prop="imei" align="center" width="140" />
            <el-table-column label="学生姓名" prop="name" align="center" />
            <el-table-column label="学号" prop="studentId" align="center" />
            <el-table-column label="学校名称" prop="schoolName" align="center" />
            <el-table-column label="年级" prop="gradeName" align="center" />
            <el-table-column label="班级" prop="className" align="center" />
            <el-table-column label="家长账号" prop="phone" align="center" />
            <el-table-column label="绑定时间" prop="bindTime" align="center" />
            <el-table-column label="操作" align="center" width="150">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="small"
                  @click="handleDSet(scope.row)"
                >
                  重置密码
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 获取API
import {
  pwdList,
  pwdReset
} from '@/api/productOperation/public/manual';
import { objectSpanMethod } from '@/utils/index';
export default {
  name: 'PwdReset',
  data() {
    return {
      searchForm: { // 搜索表单
        phone: '',
        imei: ''
      },
      listLoading: false, // 表格刷新loading
      pwdlList: [] // 列表
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    inputNum(value, item) {
      this.searchForm[item] = value.replace(/^\.+|[^\d.]/g, '');
    },
    // 向下合并单元格
    objectRowSpanHandle({ row, column, rowIndex, columnIndex }) {
      return objectSpanMethod.rowMethod({ row, column, rowIndex, columnIndex }, 'phone', [7, 9]);
    },
    // 重置
    resetInput() {
      this.searchForm = {
        phone: '',
        imei: ''
      };
      this.getInfo();
    },
    // 重置密码
    handleDSet(row) {
      console.log(row);
      this.$confirm('确认重置密码吗？', '重置密码', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        pwdReset(row.phone).then(res => {
          if (res.code === '0' && res.data) {
            const newpwd = res.data;
            this.$alert('<strong>恭喜您，重置密码成功！</strong><p>关闭弹框后，重置密码将不再显示，请妥善保存</p><p> 新密码为:' + newpwd + '</p>', '温馨提示', {
              dangerouslyUseHTMLString: true,
              confirmButtonText: '确定',
              type: 'warning'
            }).then(() => {
              this.getInfo();
            });
          }
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置密码'
        });
      });
    },
    // 获取列表
    getInfo() {
      this.listLoading = true;
      console.log(this.searchForm);
      pwdList(this.searchForm)
        .then(result => {
          if (result.code === '0' && result.data && result.data.length > 0) {
            // 处理向下列的合并单元格，同一个家长账号下
            this.pwdlList = objectSpanMethod.listDataMethod(result.data, 'phone', 'cardUserVOList');
          } else {
            this.pwdlList = [];
          }
          this.listLoading = false;
        })
        .catch(err => {
          console.log(err);
          this.listLoading = false;
          this.pwdlList = [];
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.applicationType-main{
  margin-top: 20px;
}
.applicationType {
  padding-bottom: 20px;
}
.handle-form-input {
  width: 150px;
}

.handle-form-input {
  width: 80%;
}
</style>
